import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { RolesService, UsuarioService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';

@Component({
  selector: 'app-modregemp',
  templateUrl: './modregemp.component.html',
  styleUrls: ['./modregemp.component.css']
})
export class ModregempComponent implements OnInit {

  usuarios: any[] = [];
  usuariosclien: any[] = [];
  usuarioscliente: any[] = [];
  //cols: any[];
  nombre = '';
  num = 0;
  cols = [
    { field: 'name', header: 'Nombre' },
    { field: 'email', header: 'Correo' },
    { field: 'job', header: 'Puesto' },
    { field: 'gender', header: 'Genero' },
    { field: 'status', header: 'Estatus' },
    { field: 'nombrerol', header: 'Rol' },
    { field: 'herramientas', header: 'Herramientas' }
];
  constructor( private usuariosservice: UsuarioService,
    private rolesService: RolesService
   ) {
  }

  ngOnInit(): void {
    swal2.showLoading();
    var observableUsuarios = this.usuariosservice.getUsuarios();

    var observableRoles = this.rolesService.getRolesNotAdmin();
    forkJoin([observableUsuarios, observableRoles]).subscribe(([usuarios, roles]) => {
      this.usuarios = usuarios;
      const rolesMap = new Map();
      for (const prop of this.usuarios) {
        if (prop.role_id !== null) {
          prop.nombrerol = roles.find(r => r.id === prop.role_id)?.name
          if (prop.nombrerol === 'Clientes') {
            this.usuarioscliente.push(prop);
          }
        }
      }
      this.usuariosclien = this.usuarioscliente
      swal2.close();
    })
    

    //Este es el código que tardaba mucho en cargar
    
    /* this.usuariosservice.getUsuarios().subscribe( async resp => { this.usuarios = resp;
   
    for await (const prop of this.usuarios) {
      swal2.showLoading();
      if (prop.role_id !== null) {
      await this.usuariosservice.getrol(prop.role_id).toPromise().then(r => {
        prop.nombrerol = r.data.attributes.name;
          if (r.data.attributes.name === 'Clientes') {
            this.usuarioscliente.push(prop);
          }
      })
      } 
    }
    this.usuariosclien = this.usuarioscliente
    swal2.close()
    } ); */
  }
}
